import { render, staticRenderFns } from "./CrewPublic.vue?vue&type=template&id=f516d204&"
import script from "./CrewPublic.vue?vue&type=script&lang=js&"
export * from "./CrewPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports